import { html, render } from "lit-html";
import Input from "../engine/input";

function questValue(value) {
  if (value == 2) {
    return "completed";
  } else if (value == 1) {
    return "started";
  } else {
    return "undefined";
  }
}

class DebugDialog {
  constructor() {
    this.overlay = document.querySelector(".overlay");
    this.dialog = document.querySelector(".debug");
    this.currentTab = 0;
    this.isDirty = true;
    this.screen = null;
  }

  handleClick(ev) {
  }

  handleRightClick() {
  }

  closeDialog() {
    document.dispatchEvent(new CustomEvent("ui.transition", {
      detail: {
        command: "CloseDialog",
      }
    }));
  }

  handleInput(input) {
    switch (input) {
      case Input.Cancel:
      case Input.ShowDebug:
        this.closeDialog();
      break;
    }
    return false;
  }

  rescale() {
    return;
  }

  activate(stage, ui) {
    this.screen = ui.screenStack[0];
    this.overlay.classList.add("is-visible");
    this.dialog.classList.add("is-visible");
    this.isDirty = true;
  }

  deactivate(context) {
    this.overlay.classList.remove("is-visible");
    this.dialog.classList.remove("is-visible");
  }

  selectTab = (id) => {
    return () => {
      this.currentTab = id;
      this.isDirty = true;
    }
  }

  isActive = (id) => {
    return this.currentTab == id ? "is-active" : "";
  }

  getPlayerTemplate(stage) {
    const player = stage.player;

    return html`
      <h3>Player</h3>
      <table>
        <tr><td>location</td><td>${stage.player.x},${stage.player.y}</td></tr>
      </table>
      <p>Has Met</p>
      <ul>
        ${[...player.social.meetings].map(met => {
          return html`
            <li>${met}</li>
          `;
        })}
      </ul>
      <h3>Game Screen</h3>
      <table>
        <tr><td>viewport width</td><td>${this.screen.width}</td></tr>
        <tr><td>viewport font size</td><td>${this.screen.viewportFontSize}</td></tr>
        <tr><td>device pixel ratio</td><td>${this.screen.grid._ratio}</td></tr>
        <tr><td>pixel width</td><td>${this.screen.canvas.width}</td></tr>
        <tr><td>pixel height</td><td>${this.screen.canvas.height}</td></tr>
        <tr><td>cell width</td><td>${this.screen.grid._cellWidth}</td></tr>
        <tr><td>cell height</td><td>${this.screen.grid._cellHeight}</td></tr>
        <tr><td>font size</td><td>${this.screen.grid._font.size}</td></tr>
      </table>
    `;
  }

  getEntitiesTemplate(stage) {
    const entities = stage.entities.filter(ent => !ent.isPlayer());
    return html`
      <h3>Entities</h3>
      <table>
      ${entities.map(entity => {
        return html`
          <tr class="quest-var">
            <td>${entity.name}</td>
            <td><button @click=${this.moveBesideEntity(stage, entity)}>Jump</button></td>
            <td>${entity.description}</td>
          </tr>
        `;
      })}
      </table>
    `;
  }

  moveBesideEntity = (stage, entity) => {
    return (ev) => {
      ev.preventDefault();
      //const openTiles = stage.adjacentOpenTiles(entity.x, entity.y);
      const openTiles = stage.adjacentPoints(entity.x, entity.y);

      if (openTiles.length > 0) {
        const index = Math.floor(Math.random() * openTiles.length);
        const point = openTiles[index];
        stage.moveEntityTo(stage.player, point.x, point.y);
        stage.refreshVisibility();
        this.closeDialog();
      }
    }
  }

  toggleQuestVariable = (stage) => {
    return (ev) => {
      ev.preventDefault();
      const id = ev.target.quest.value || `Var${Math.random().toString().slice(2)}`;
      const state = ev.target.state.value;
      switch (state) {
        case "cancelQuest": stage.adventure.cancelQuest(id); break;
        case "startQuest": stage.adventure.startQuest(id); break;
        case "completeQuest": stage.adventure.completeQuest(id); break;
      }
      this.isDirty = true;
    }
  }

  getQuestVariablesTemplate(stage) {
    const questVariables = [...stage.adventure.quests];
    return html`
      <h3>Quest Variables</h3>
      <table>
      ${questVariables.map(quest => {
        return html`
          <tr class="quest-var">
            <td>${quest[0]}</td>
            <td>${questValue(quest[1])}</td>
            <td>
              <form @submit=${this.toggleQuestVariable(stage)}>
                <input type="hidden" name="quest" value=${quest[0]}>
                <select name="state">
                  <option value="startQuest">startQuest</option>
                  <option value="completeQuest">completeQuest</option>
                  <option value="cancelQuest">cancelQuest</option>
                </select>
                <input type="submit" value="Toggle">
              </form>
            </td>
          </tr>
        `;
      })}
      </table>
      <form @submit=${this.toggleQuestVariable(stage)}>
        <select name="state">
          <option value="startQuest">startQuest</option>
          <option value="completeQuest">completeQuest</option>
        </select>
        <input type="text" name="quest" value="" placeholder="YourQuestVar">
        <input type="submit" value="Add">
      </form>
    `;
  }

  getCurrentTab(stage) {
    switch (this.currentTab) {
      case 0: return this.getPlayerTemplate(stage);
      case 1: return this.getEntitiesTemplate(stage);
      case 2: return this.getQuestVariablesTemplate(stage);
    }
  }

  getControlsTemplate(stage) {
    return html`
      <div class="control">
        <input type="number" id="x" value="0" min="0" max="${stage.width}">
        <input type="number" id="y" value="0" min="0" max="${stage.height}">
        <button>Move Player</button>
      </div>
    `;
  }

  getDialogTemplate(stage) {
    return html`
      <nav>
        <button @click=${this.selectTab(0)} class=${this.isActive(0)}>Player</button>
        <button @click=${this.selectTab(1)} class=${this.isActive(1)}>Entities</button>
        <button @click=${this.selectTab(2)} class=${this.isActive(2)}>Quest Variables</button>
      </nav>
      <div class="sheet">
        ${this.getCurrentTab(stage)}
      </div>
    `;
  }

  render(stage) {
    if (this.isDirty) {
      render(this.getDialogTemplate(stage), this.dialog);
      this.isDirty = false;
    }
  }
}

export default DebugDialog;
